import axios from 'axios';

import { applications } from 'z-js-commons';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';
import { fixExerciseStructure } from '../lib/exerciseTransformations/fixExerciseStructure';
import { handleUnauthorizedError } from '../lib/heartBeat';

export function getHomework(id) {
    const url = `${API_URL}/cv/homework/${id}`;
    return async dispatch => {
        dispatch({ type: types.GET_HOMEWORK });
        try {
            const { data } = await axios.get(url);
            if (data.exercises) {
                dispatch({
                    type: types.GET_HOMEWORK_SUCCESS,
                    res: {
                        homeworkId: data._id,
                        homeworkDescription: data.description,
                        homeworkExercises: data.exercises.map(fixExerciseStructure),
                        homeworkTitle: data.publicTitle,
                        homeworkTaxonomy: data.taxonomy,
                        isEditorialHomework: !data.UGC
                    }
                });
            } else {
                dispatch({
                    type: types.GET_HOMEWORK_FAILURE
                });
            }
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.GET_HOMEWORK_FAILURE,
                error: e
            });
        }
    };
}

// unused
export function changeDetailInputStyle() {
    return {
        type: types.CHANGE_DETAIL_INPUT_STYLE
    };
}

export function changeHomeworkDetailTitle(homeworkTitle) {
    return {
        type: types.CHANGE_HOMEWORK_DETAIL_TITLE,
        homeworkTitle
    };
}

export function changeHomeworkDetailDescription(homeworkDescription) {
    return {
        type: types.CHANGE_HOMEWORK_DETAIL_DESCRIPTION,
        homeworkDescription
    };
}

export function closeDeleteHomeworkModal() {
    return {
        type: types.CLOSE_DELETE_HOMEWORK_MODAL
    };
}

export function openDeleteHomeworkModal() {
    return {
        type: types.OPEN_DELETE_HOMEWORK_MODAL
    };
}

export function deleteHomework(userId, homeworkId, history) {
    const url = `${API_URL}/cat/homework/${homeworkId}`;
    return async dispatch => {
        dispatch({ type: types.DELETE_HOMEWORK });
        try {
            await axios.delete(url);
            history.push('/myLibrary');
            dispatch({
                type: types.DELETE_HOMEWORK_SUCCESS,
                id: homeworkId
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({ type: types.DELETE_HOMEWORK_FAILURE });
        }
    };
}

export function saveHomework(homework, redirect) {
    const url = `${API_URL}/cat/homework`;
    const items =
        homework.exercises &&
        Array.isArray(homework.exercises) &&
        homework.exercises.map(e =>
            e.filteringBooks ? { id: e.id, context: e.contextId, filteringBooks: e.filteringBooks } : { id: e.id, context: e.contextId }
        );
    return async dispatch => {
        dispatch({ type: types.SAVE_HOMEWORK });
        const bodyPost = {
            ...homework,
            items,
            applicationId: applications.CREA_VERIFICHE
        };
        try {
            const { data } = await axios.post(url, bodyPost);
            dispatch({
                type: types.SAVE_HOMEWORK_SUCCESS,
                homework: {
                    ...homework,
                    _id: data.originalId
                },
                homeworkId: data.originalId
            });
            if (redirect) {
                redirect();
            }
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.SAVE_HOMEWORK_FAILURE,
                error: e
            });
        }
    };
}

export function updateHomework(homework, uid, homeworkId, redirect) {
    const url = `${API_URL}/cat/homework/${homeworkId}`;
    return async dispatch => {
        dispatch({
            type: types.UPDATE_HOMEWORK,
            homework,
            homeworkId
        });

        const items =
            homework.exercises &&
            Array.isArray(homework.exercises) &&
            homework.exercises.map(e =>
                e.filteringBooks
                    ? { id: e.id, context: e.contextId, filteringBooks: e.filteringBooks, subject: e.subject.name }
                    : { id: e.id, context: e.contextId, subject: e.subject.name }
            );
        const body = {
            title: homework.title,
            description: homework.description,
            ownerId: homework.ownerId,
            items,
            applicationId: applications.CREA_VERIFICHE,
            status: 1
        };
        try {
            await axios.put(url, body);

            dispatch({
                type: types.UPDATE_HOMEWORK_SUCCESS,
                homework: {
                    ...body,
                    id: homeworkId
                }
            });
            if (redirect) {
                redirect();
            }
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({ type: types.UPDATE_HOMEWORK_FAILURE });
        }
    };
}

export function addExerciseToHomework(idHomework, exerciseAddedToHomework) {
    return {
        type: types.ADD_EXERCISE_TO_HOMEWORK,
        exercise: exerciseAddedToHomework,
        idHomework: idHomework
    };
}

export function removeExerciseFromHomework(idHomework, exerciseIdRemovedFromHomework) {
    return {
        type: types.REMOVE_EXERCISE_FROM_HOMEWORK,
        exerciseId: exerciseIdRemovedFromHomework,
        idHomework: idHomework
    };
}

export function addExercisesToHomework(exercisesToAdd, newAddedExercises) {
    return {
        type: types.ADD_EXERCISES_TO_HOMEWORK,
        exercisesToAdd,
        newAddedExercises
    };
}

export function reorderHomeworkExercises(exercises) {
    return {
        type: types.REORDER_HOMEWORK_EXERCISES,
        exercises: exercises
    };
}

export function closeCancelHomeworkModal() {
    return {
        type: types.CLOSE_CANCEL_HOMEWORK_MODAL
    };
}

export function openCancelHomeworkModal() {
    return {
        type: types.OPEN_CANCEL_HOMEWORK_MODAL
    };
}
